import { IGetMotivosAfastamentoDropDownUseCase } from "../../../presentation/useCases/read/get_motivos_afastamento_dropdown_use_case";
import { MotivoAfastamentoDropDown } from "../../models/motivo_afastamento_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetMotivosAfastamentoDropDownUseCase
 */

export class GetMotivosAfastamentoDropDownUseCase implements IGetMotivosAfastamentoDropDownUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getMotivosAfastamentoDropDown(): Promise<MotivoAfastamentoDropDown[]> {
    const response = await this.repository.getMotivosAfastamentoDropDown();
    return response;
  }
}